// extracted by mini-css-extract-plugin
module.exports = {"backBtnBox":"BackBtn_backBtnBox__3Gxh4","backBtn":"BackBtn_backBtn__1CKcX"};